<div class="container header-content">
    <div class="header-row">
        <div class="mobile-menu-wrapper d-lg-none">
            <app-mobile-menu
                [menuGroups]="(navigationService.menu$ | async)?.children"
                [metaMenuItems]="navigationService.metaMenu$ | async"
            ></app-mobile-menu>
        </div>
        <div class="logo-wrapper">
            <div class="logo">
                <a
                    class="logo-link"
                    [routerLink]="'/'"
                    *ngIf="(settingsService.settings$ | async)?.headerContent?.headerLogo as headerLogo"
                >
                    <img
                        class="logo-image"
                        [src]="headerLogo?.src"
                        [alt]="headerLogo?.name"
                        [width]="headerLogo?.width ?? 200"
                        [height]="headerLogo?.height ?? 50"
                    />
                </a>
            </div>
        </div>
        <div class="header-action-wrapper">
            <div class="search-field d-none d-lg-block">
                <app-search-container
                    *ngIf="!(breakpointMinService.breakpoint$ | async)?.isTabletOrSmaller"
                ></app-search-container>
            </div>
            <div class="header-section">
                <app-meta-menu [metaMenuLinks]="navigationService.metaMenu$ | async"></app-meta-menu>
                <app-header-basket-link></app-header-basket-link>
            </div>
        </div>
    </div>
    <div class="header-row d-none d-lg-block">
        <app-main-menu
            [menuGroups]="(navigationService.menu$ | async)?.children"
            (updateActiveIndexEvent)="onUpdateActiveIndexEvent($event)"
        ></app-main-menu>
    </div>

    <div class="header-row d-lg-none" *ngIf="(breakpointMinService.breakpoint$ | async)?.isTabletOrSmaller">
        <div class="search-field-mobile">
            <app-search-container></app-search-container>
        </div>
    </div>
</div>
<app-progress></app-progress>
